export default __webpack_public_path__ + "media/images/react_icons/medal-08f41ed4f45d203fba95f0d594f44c33.svg";